import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AlignmentConstants} from 'search/blast/constants';
import {FONT_FAMILY_MONOSPACED} from 'styles/FontConstants';

interface AlignmentTickProps {
  tick: number; // 1-based tick position
  isCompact: boolean;
}

export default function AlignmentTick({tick, isCompact}: AlignmentTickProps): JSX.Element {
  return (
    <div className={css(styles.tickContainer, isCompact && styles.compactContainer)}>
      <span className={css(styles.tickLabel)}>{tick}</span>
      <div className={css(styles.tickBar)} />
    </div>
  );
}

const styles = StyleSheet.create({
  tickContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: AlignmentConstants.columnGap.normal,
    alignItems: 'center',
    justifyContent: 'center',
  },
  compactContainer: {
    gap: AlignmentConstants.columnGap.compact,
  },
  tickLabel: {
    fontSize: '14px',
    fontFamily: FONT_FAMILY_MONOSPACED,
    userSelect: 'none',
  },
  tickBar: {
    height: '7px',
    width: '1px',
    backgroundColor: Color.GRAY_300,
  },
});
